<div [class]="['modal-header', slot()]">
  <ng-content></ng-content>
</div>